import { useState, useCallback } from 'react';

export default function useVisible(
  initialValue?: boolean,
): [boolean | undefined, () => void, () => void] {
  const [visible, setVisible] = useState<boolean | undefined>(initialValue);

  const show = useCallback(() => {
    setVisible(true);
  }, []);

  const hide = useCallback(() => {
    setVisible(false);
  }, []);

  return [visible, show, hide];
}
